<template>
  <div class="mgt-20px">
    <div class="card">
      <header class="header-card">
        <p>
          {{ $t('face.faces') }}
        </p>
      </header>
      <div class="card-content">
          <div class="level level-right">
            <button class="button is-primary" @click="addNewFace()">
              {{ $t('face.ajouterFace') }}
            </button>
          </div>
        <div v-for="(face, index) in materiel.faces" :key="index" class="mgt-25px"
             :class="{'faceSelectionnee' :
             face.id === $route.params.idFace && $route.params.idFace}">
          <div class="card has-background-background"
               :class="{'mgb-40px' : index + 1 === materiel.faces.length}">
            <div class="columns is-multiline card-content is-marginless is-paddingless">
              <div class="column is-11">
                <div class="columns is-multiline">
                  <div class="column is-2">
                    <b-field :label="$t('face.code')"
                      :class="{'obligatoire': !societeActive.masqueCodeFace}">
                      <b-input v-model="face.code" :disabled="!face.actif">
                      </b-input>
                    </b-field>
                  </div>
                  <div class="column is-3">
                    <parametre-autocomplete
                      :label="$t('face.motifNonCommercialisation')"
                      :target="constantes.PARAMETRES_KEYS.faceMotifNonCom"
                      :disabled="!face.actif"
                      v-model="face.faceMotifNonComId"
                      expanded
                      custom-class="ellipsis"
                    />
                  </div>
                  <div v-if="!face.actif" class="column is-3">
                    <b-field :label="$t('face.etat')">
                      <b-select v-model="face.etat" expanded>
                        <option v-for="etat in demonteState.etatDispositifPublicitaireDemonte"
                                :value="etat.value" :key="etat.value">
                          {{ $t(etat.libelle) }}
                        </option>
                      </b-select>
                    </b-field>
                  </div>
                  <div v-if="face.actif" class="column is-3">
                    <b-field :label="$t('face.etat')">
                      <b-select v-model="face.etat" expanded>
                        <option v-for="etat in demonteState.etatDispositifPublicitaire"
                                :value="etat.value" :key="etat.value">
                          {{ $t(etat.libelle) }}
                        </option>
                      </b-select>
                    </b-field>
                  </div>
                  <div class="column is-2">
                    <b-field :label="$t('face.dateMontage')" custom-class="ellipsis">
                      <b-datepicker show-week-number v-model="face.dateMontage"
                                    :disabled="!face.actif"
                                    icon="calendar-today"
                                    nearby-selectable-month-days
                                    :editable="true" position="is-bottom-left">
                      </b-datepicker>
                    </b-field>
                  </div>
                  <div class="column is-2">
                    <b-field :label="$t('face.dateDemontage')" custom-class="ellipsis">
                      <b-datepicker show-week-number v-model="face.dateDemontage"
                                    icon="calendar-today"
                                    :disabled="!face.actif"
                                    nearby-selectable-month-days
                                    :editable="true" position="is-bottom-left">
                      </b-datepicker>
                    </b-field>
                  </div>
                  <div class="column is-2">
                    <qd-checkbox
                      v-model="face.proposableLc"
                      :disabled="!face.actif"
                      class="has-text-weight-bold has-text-default">
                      {{ $t('face.proposableLc') }}
                    </qd-checkbox>
                  </div>
                  <div class="column is-3">
                    <qd-checkbox
                      v-model="face.proposableReseau"
                      :disabled="!face.actif"
                      class="has-text-weight-bold has-text-default">
                      {{ $t('face.proposableReseau') }}
                    </qd-checkbox>
                  </div>
                  <div class="column is-3">
                    <qd-checkbox
                      v-model="face.declarableEnMairie"
                      :disabled="!face.actif"
                      class="has-text-weight-bold has-text-default">
                      {{ $t('face.declarableMairie') }}
                    </qd-checkbox>
                  </div>
                </div>
              </div>
              <div class="column is-1 mg-auto has-text-right">
                <b-tooltip type="is-primary"
                           position="is-left"
                           :label="$t('detailFace.faceArchive')">
                  <b-icon icon="information"
                          v-if="!face.actif"
                          type="is-primary">
                  </b-icon>
                </b-tooltip>
                <b-dropdown position="is-bottom-left" aria-role="list" class="has-text-left">
                  <a slot="trigger">
                    <b-icon icon="dots-vertical" type="is-default"></b-icon>
                  </a>
                  <b-dropdown-item>
                    <p class="is-default is-size-6" @click="dupliquerFace(face)">
                      {{ $t('general.button.dupliquer')}}
                    </p>
                  </b-dropdown-item>
                  <b-dropdown-item>
                    <p class="is-default is-size-6" @click="saveIndexToDelete(index)">
                      {{ $t('general.button.delete')}}
                    </p>
                  </b-dropdown-item>
                </b-dropdown>
              </div>
            </div>
            <div class="column has-text-left">
              <a class="" @click="setIndexCollapse(index)"
                aria-controls="contentIdForA11y2">
                <b-tooltip type="is-primary"
                      position="is-right"
                      :label="$t('general.divers')">
                      <b-icon class="animationChevron"
                        :icon="hasIndexCollapse(index) ?
                        'chevron-down' : 'chevron-right'"
                        >
                      </b-icon>
                </b-tooltip>
              </a>
            </div>
            <qd-collapse
              aria-id="contentIdForA11y2"
              class="panel"
              animation="slide"
              v-if="hasIndexCollapse(index)">
              <hr class="dropdown-divider">
              <div class="columns is-marginless">
                <div class="column is-2">
                  <b-field :label="$t('face.oldReference')">
                    <b-input v-model="face.ancienneReference">
                    </b-input>
                  </b-field>
                </div>
                <div class="column is-3">
                  <b-field :label="$t('face.information')">
                    <b-input v-model="face.information" type="textarea" row="2">
                    </b-input>
                  </b-field>
                </div>
              </div>
            </qd-collapse>
          </div>
        </div>
      </div>
    </div>
    <b-modal v-model="popUpSuppression" has-modal-card class="modal">
      <app-pop-up-suppression
        oncancel="closePopUp()"
        :messHeader="$t('face.delete')"
        :messFooter="$t('face.irreversible')"
        :isErrorPopup="false"
        :messagesPopup="[]"
        :cancel="$t('general.non')"
        :validate="$t('general.oui')"
        @no="popUpSuppression = false"
        @yes="supprimerFace">
      </app-pop-up-suppression>
    </b-modal>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import genererFace from '@/services/gabed/face/genererFace';
import { PARAMETRES_KEYS } from '@/store/modules/parametres-mutation-type';
import { ETAT_DISPOSITIF_PUBLICITAIRE, ETAT_DISPOSITIF_PUBLICITAIRE_DEMONTE } from '@/configuration/gabed/dispositif/dispositifPublicitaire';
import popUpSuppression from '@/components/general/popUpPrevention';
import messageInformation from '@/services/general/messageInformation';
import parametreAutocomplete from '@/components/general/autocomplete/parametreAutocomplete';

const Attachments = createNamespacedHelpers('attachments');
const Societe = createNamespacedHelpers('societe');

export default {
  name: 'm_face',
  props: {
    materiel: {
      type: Object,
      required: true,
    },
  },
  components: {
    appPopUpSuppression: popUpSuppression,
    parametreAutocomplete,
  },
  data() {
    return {
      popUpSuppression: false,
      demonteState: {
        etatDispositifPublicitaireDemonte: ETAT_DISPOSITIF_PUBLICITAIRE_DEMONTE,
        etatDispositifPublicitaire: ETAT_DISPOSITIF_PUBLICITAIRE,
      },
      indexFaceDelete: null,
      indexCollapse: [],
      constantes: {
        PARAMETRES_KEYS,
      },
    };
  },
  computed: {
    ...Societe.mapGetters({
      societeActive: 'societeActive',
    }),
  },
  methods: {
    ...Attachments.mapActions({
      setAttachmentContext: 'setContext',
      setAttachmentElementId: 'setElementId',
    }),
    addNewFace() {
      const face = genererFace();
      face.declarableEnMairie = this.materiel.declarableEnMairie;
      face.dateMontage = this.materiel.dateMontage;
      face.dateDemontage = this.materiel.dateDemontage;
      face.etat = this.materiel.etat;
      this.materiel.faces.unshift(face);
      this.gestionFacesDeclarableEnMairie();
    },
    dupliquerFace(face) {
      const newFace = cloneDeep(face);
      newFace.actif = true;
      this.materiel.faces.push(newFace);
      this.materiel.faces[this.materiel.faces.length - 1].id = null;
    },
    saveIndexToDelete(index) {
      this.indexFaceDelete = index;
      this.popUpSuppression = true;
      return null;
    },
    supprimerFace() {
      this.materiel.faces.splice(this.indexFaceDelete, 1);
      this.popUpSuppression = false;
    },
    gestionFacesDeclarableEnMairie() {
      if (!this.materiel.faces.length) return;
      if (this.materiel.faces.every(face => !face.declarableEnMairie)
          && this.materiel.declarableEnMairie) {
        this.materiel.declarableEnMairie = false;
        messageInformation(this.$t('materiel.messageInformations.touteLesFacesSontNonDeclarable'), 'is-warning');
      }
      if (this.materiel.faces.some(face => face.declarableEnMairie)
          && !this.materiel.declarableEnMairie) {
        this.materiel.declarableEnMairie = true;
        messageInformation(this.$t('materiel.messageInformations.uneDesFacesEstDeclarable'), 'is-warning');
      }
    },
    hasIndexCollapse(index) {
      return this.indexCollapse.includes(index);
    },
    setIndexCollapse(index) {
      if (this.hasIndexCollapse(index)) {
        this.indexCollapse.splice(this.indexCollapse.indexOf(index), 1);
        return;
      }
      this.indexCollapse.push(index);
    },
  },
  mounted() {
    if (this.materiel.faces.length === 0) this.addNewFace();
  },
};
</script>

<style scoped>

</style>
